import legacyRules from '../data/product-legacy-image-rules.json'

type LegacyRule = { image: string; terms: string[] }

const RULES = legacyRules as LegacyRule[]

/** Map catalog product name → filename under `public/products/` (legacy box art names). */
export function legacyImageForProductName(name: string): string | null {
  const n = name.trim().toLowerCase()
  if (!n) return null

  let best: { image: string; termLength: number } | null = null
  for (const rule of RULES) {
    for (const term of rule.terms) {
      const t = term.trim().toLowerCase()
      if (!t || !n.includes(t)) continue
      if (!best || t.length > best.termLength) {
        best = { image: rule.image, termLength: t.length }
      }
    }
  }
  return best?.image ?? null
}
